import { Box, BoxProps, Text } from '@chakra-ui/react';
import _ from 'lodash';
import { FC } from 'react';
import AsyncSelect from 'react-select/async';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { Option } from 'types/Option';
export interface CbAsyncAutoCompleteSelectProps extends BoxProps {
  onOptionChange: (value: Option) => void;
  setActiveValue?: (value: Option) => void;
  defaultOptions: Option[];
  placeholder: string;
  getData: (inputValue: string) => Promise<Option[]>;
  defaultInputValue?: string;
}
export const CbAsyncAutoCompleteSelect: FC<CbAsyncAutoCompleteSelectProps> = ({
  onOptionChange,
  setActiveValue,
  defaultOptions,
  placeholder,
  getData,
  defaultInputValue,
  ...props
}) => {
  const handleChange: any = (selectedOption: {
    id: number;
    value: string;
  }) => {
    onOptionChange(selectedOption);
    setActiveValue && setActiveValue(selectedOption);
  };
  const _loadOptions = async (inputValue: string) => {
    return getData(inputValue);
  };
  const loadOptions = _.debounce(_loadOptions, 100);
  const customStyles = {
    control: () => ({
      borderWidth: 0,
      width: '100%',
      backgroundColor: 'transparent',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
      padding: 2
    }),
    indicatorSeparator: provided => ({
      ...provided,
      width: 0
    })
  };
  const placeholderComponent = <Text>
      <ICON_BY_NAME.search marginRight={2} marginBottom={1} />
      {placeholder}
    </Text>;
  return <Box borderWidth="1px" borderRadius={50} borderColor={'cloud.300'} {...props} data-sentry-element="Box" data-sentry-component="CbAsyncAutoCompleteSelect" data-sentry-source-file="CbAsyncAutoCompleteSelect.tsx">
      <AsyncSelect aria-label="async-selector" defaultOptions={defaultOptions} onChange={handleChange} placeholder={placeholderComponent} loadOptions={loadOptions} styles={customStyles} defaultInputValue={defaultInputValue} data-sentry-element="AsyncSelect" data-sentry-source-file="CbAsyncAutoCompleteSelect.tsx" />
    </Box>;
};